import React, { useEffect } from "react";
import { Row, Col, Typography, List, Image } from "antd";
import { appInsights } from "../../core/services/insight.service";

const { Title } = Typography;

const Home: React.FC = () => {
  useEffect(() => {
    document.body.classList.add("layout-124", "band-small");
    showSideNav(true);
  }, []);

  const showSideNav = (show: boolean): void => {
    
  };

  const quickLinks = [
    { text: "Enter Business Unit Request", url: "/enter request/ccrequest" },
    { text: "Enter Account Request", url: "/enter request/accreqeuest" },
    { text: "Requests Pending My Action", url: "/manage requests/mypendingaction" },
    { text: "My Open Requests", url: "/manage requests/myopenrequests" },
    { text: "Search for Requests", url: "/manage requests/searchrequests" }, // Update this path if you have a specific search route
  ];

  return (
    <div className="layout">
      <div style={{ padding: "0 50px" }}>
        <Row style={{ marginBottom: "20px", marginTop: "40px" }}>
          <Col span={8}>
            <div
              style={{
                background: "#009dd9",
                width: "350px",
                height: "110px",
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
                padding: "10px",
              }}
            >
              <Title level={4} style={{ color: "white" }}>
                Welcome to the Accounts Request Application
              </Title>
            </div>
          </Col>
          <Col span={8} style={{ textAlign: "center" }}>
            <Image
              src="images/mband.jpg"
              width={350}
              height={110}
              alt="Accounts Request Application"
            />
          </Col>
          <Col span={6} offset={2}>
            <div className="site-layout-background">
              <Title level={4}>Quick Links</Title>
              <List
                dataSource={quickLinks}
                renderItem={(item) => (
                  <List.Item
                    style={{
                      fontFamily: "Arial, Helvetica, sans-serif",
                      fontSize: "11.5px",
                      borderBottom: "none",
                    }}
                  >
                    <a href={item.url}>{item.text}</a>
                  </List.Item>
                )}
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Home;
